import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { services } from '../data/services';
import { motion } from 'framer-motion';
import ServicesGrid from '../components/ServicesGrid';

const ServiceDetail: React.FC = () => {
  const { serviceId } = useParams();
  const navigate = useNavigate();
  
  const service = services.find(s => s.id === Number(serviceId));
  
  if (!service) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-white to-gray-50 py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Service Not Found</h1>
          <button 
            onClick={() => navigate('/services')}
            className="px-6 py-3 bg-masa-blue text-white rounded-lg hover:bg-masa-blue/90 transition-colors"
          >
            View All Services
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50">
      {/* Hero Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <div className="inline-block p-3 bg-masa-blue/10 rounded-full mb-6">
            <span className="text-4xl">{service.icon}</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            {service.title}
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {service.shortDesc}
          </p>
        </motion.div>

        {/* Service Details */}
        <div className="grid md:grid gap-12 mb-24">
          <div className="space-y-8">
            <div className="bg-white p-8 rounded-xl shadow-lg border border-gray-100">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Service Overview</h2>
              <div className="prose prose-lg">
                {service.longDesc}
              </div>
            </div>
          </div>
        </div>

        {/* Other Services Section */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">
            Explore Our Other Services
          </h2>
          <ServicesGrid imageHeightClass="h-80" />
        </div>
      </div>
    </div>
  );
};

export default ServiceDetail;